import { UserAppPreferenceCommonFilters } from '../../../Core/Users/models/user-app-preferences-filters.model';
import { FilterTypeModel } from './abstract-filter-type.model';

export abstract class AuditableFiltersModel {
    protected auditableValues: UserAppPreferenceCommonFilters;

    constructor(filters: UserAppPreferenceCommonFilters) {
        this.auditableValues = {
            name: filters.name,
            createdBy: filters.createdBy,
            createdDate: filters.createdDate,
            modifiedBy: filters.modifiedBy,
            modifiedDate: filters.modifiedDate
        };
    }

    public abstract getAllFilters(): FilterTypeModel[];
    public abstract setAllFilters(filtersToSet: FilterTypeModel[], filterValues: UserAppPreferenceCommonFilters);
    public abstract setNewValues(newFilters: FilterTypeModel[]);
    public abstract getFilterValues(): UserAppPreferenceCommonFilters;

    // TODO: Some common way to access id names
    protected setAuditableFilters(filtersToSet: FilterTypeModel[], auditableFilterValues: UserAppPreferenceCommonFilters) {
        filtersToSet.find(filter => filter.id === 'name')?.setValue(auditableFilterValues.name);
        filtersToSet.find(filter => filter.id === 'createdBy')?.setValue(auditableFilterValues.createdBy);
        filtersToSet.find(filter => filter.id === 'createdDate')?.setValue(auditableFilterValues.createdDate);
        filtersToSet.find(filter => filter.id === 'modifiedBy')?.setValue(auditableFilterValues.modifiedBy);
        filtersToSet.find(filter => filter.id === 'modifiedDate')?.setValue(auditableFilterValues.modifiedDate);
    }

    protected setNewAuditableFilterValues(newFilters: FilterTypeModel[]) {
        this.auditableValues.name = newFilters.find(filter => filter.id === 'name')?.getValue();
        this.auditableValues.createdBy = newFilters.find(filter => filter.id === 'createdBy')?.getValue();
        this.auditableValues.createdDate = newFilters.find(filter => filter.id === 'createdDate')?.getValue();
        this.auditableValues.modifiedBy = newFilters.find(filter => filter.id === 'modifiedBy')?.getValue();
        this.auditableValues.modifiedDate = newFilters.find(filter => filter.id === 'modifiedDate')?.getValue();
    }

    protected getAuditableFilterValues(): UserAppPreferenceCommonFilters {
        return this.auditableValues;
    }
}
